export enum EstateSelectCardTypes {
  Purchased = "purchased",
  Empty = "empty",
  Blocked = "blocked",
}
